import { LifeBuoy } from 'lucide-react';
import { Button } from '@/components/ui/button';

// Inline header trigger for the bug-report widget. Presentational — the parent
// BugReportWidget owns the open state + auth gating via the `onClick` prop.
export default function BugReportButton({ onClick }) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      onClick={onClick}
      title="Abrir incidencia de soporte"
      aria-label="Abrir incidencia de soporte"
    >
      <LifeBuoy className="w-4 h-4" />
    </Button>
  );
}
